module.exports = __webpack_public_path__ + "static/chrome-ore-8e18506a45811be993ebd8f29ccf1054.png";